import useAxios from "axios-hooks";

export const useCategories = () => {
    const [{ data, loading, error }, refetch] = useAxios("/api/categories");

    return [data, loading, error, refetch];
};
